/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { assert } from '@fluidframework/common-utils';
export function getIds(range) {
    const { ids } = range;
    if (ids === undefined) {
        return undefined;
    }
    let first = ids.first;
    let last = ids.last;
    const overrides = ids;
    if (overrides.overrides !== undefined) {
        first !== null && first !== void 0 ? first : (first = overrides.overrides[0][0]);
        last !== null && last !== void 0 ? last : (last = overrides.overrides[overrides.overrides.length - 1][0]);
    }
    assert(first !== undefined && last !== undefined, 0x656 /* malformed IdCreationRange */);
    return {
        first,
        last,
        overrides: overrides.overrides,
    };
}
//# sourceMappingURL=IdRange.js.map